import { makeStyles } from '@material-ui/core/styles'

const useTableStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    textTransform: 'capitalize',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}))

export default useTableStyles
